import { useEffect } from "react";
import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import {
  JOrder,
  resetForm,
  setAssignDriverDialog,
} from "../../../../app/slices/jomla/orderSlice";
import { SelectDriver } from "../../../../components/Selectors/jomla/SelectDriver";
import { HiOutlineTruck, HiOutlineUser } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";

const AssignOrderToDriverForm = (props) => {
  const dispatch = useDispatch();

  const _JOrder = useSelector((state) => state.jOrder.assignDriver);
  const drivers = useSelector((state) => state.user.driversList.data);
  const _SearchBody = useSelector((state) => state.jOrder.searchBody);

  const { control, reset, handleSubmit, setValue } = useForm({
    defaultValues: _JOrder.form,
  });

  const onSubmit = (data) => {
    dispatch(
      JOrder.assignDriver(
        _JOrder.form.order_id,
        {
          driver_id: data.driver_id,
        },
        _SearchBody,
        props.orderDetails
      )
    );
  };

  useEffect(() => {
    reset({ ..._JOrder.form });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_JOrder.form]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDialog = () => {
    dispatch(setAssignDriverDialog({}));
  };

  return (
    <FormDialog
      open={_JOrder.dialog}
      onClose={() => {
        handleDialog();
      }}
      icon={<HiOutlineTruck />}
      title={"تعيين الطلب الى سائق"}
      subtitle="اختر السائق لتعيين الطلب له"
      onSubmit={handleSubmit(onSubmit)}
      saving={_JOrder.loading}
      loading={_JOrder.loading}
    >
      <SectionCard icon={<HiOutlineUser />} title="السائق">
        <Grid item xs={12}>
          <Controller
            control={control}
            name={"driver_id"}
            render={({ field }) => (
              <SelectDriver
                {...field}
                required
                onChange={(e, newValue) => {
                  setValue("driver_id", newValue ? newValue.id : null);
                }}
                value={drivers.filter((x) => x.id === field.value)[0] ?? null}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default AssignOrderToDriverForm;
